import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast } from "#app/notifications";
import { deleteCustomMaterials } from "#modules/materials/infra/deleteCustomMaterials.api";
import { materialsQuery } from "#modules/materials/infra/materials.query";

export const useDeleteCustomMaterials = () => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: deleteCustomMaterials,
    onSuccess: () => {
      void queryClient.invalidateQueries(materialsQuery());
    },
    onError: (err: Error) => {
      showErrorToast({ title: err.message });
      errorHandler(err);
    },
  });

  return { deleteCustomMaterials: mutate, ...rest };
};
